import script from "./KMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./KMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./KMenuItem.vue?vue&type=style&index=0&id=5654ca82&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5654ca82"]])

export default __exports__